'use client';

import { Check, Circle } from 'lucide-react';

/**
 * Live-чек-лист требований к паролю.
 * Правила синхронизированы с серверным `validate_password_strength`
 * в `api/app/routers/auth.py`.
 */
export function PasswordChecklist({ value, className }: { value: string; className?: string }) {
  const safe = typeof value === 'string' ? value : '';
  const rules: { ok: boolean; label: string }[] = [
    { ok: safe.length >= 10, label: 'Минимум 10 символов' },
    { ok: /[A-Za-z\u0400-\u04FF]/.test(safe), label: 'Хотя бы одна буква' },
    { ok: /\d/.test(safe), label: 'Хотя бы одна цифра' },
    { ok: safe.length > 0 && safe === safe.trim(), label: 'Без пробелов в начале и в конце' },
  ];
  return (
    <ul className={`mt-2 space-y-1 text-xs ${className ?? ''}`}>
      {rules.map((rule) => (
        <li
          key={rule.label}
          className={`flex items-center gap-1.5 ${
            rule.ok ? 'text-emerald-600 ' : 'text-[var(--app-text-soft)]'
          }`}
        >
          {rule.ok ? (
            <Check className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          ) : (
            <Circle className="h-3 w-3 shrink-0" aria-hidden="true" />
          )}
          <span>{rule.label}</span>
        </li>
      ))}
    </ul>
  );
}

export function isPasswordValid(value: string): boolean {
  if (typeof value !== 'string') return false;
  if (value.length < 10 || value.length > 128) return false;
  if (value !== value.trim()) return false;
  if (!/[A-Za-z\u0400-\u04FF]/.test(value)) return false;
  if (!/\d/.test(value)) return false;
  return true;
}
